<div class="mic-vad-container">
  <!-- Listening animation wrapper -->
  <div class="listening-animation-wrapper" *ngIf="status() === 'listening'">
    <div class="wave-circle wave-1"></div>
    <div class="wave-circle wave-2"></div>
  </div>
  
  <!-- Button with standard classes -->
  <button pButton type="button" [icon]="buttonIcon()" [class]="buttonClass" [ngClass]="buttonClasses()" (click)="toggleRecording()"></button>
  
  <!-- Status description (commented out) -->
  <!--   
  @if (statusDescription()) {
    <div class="status-description" [ngClass]="'status-' + status()">
      {{ statusDescription() }}
    </div>
  } -->
</div>
